import { templateCompanyAuthenticationForm } from '../view/template';
import { BaseWebComponentController } from '../../../../framework/BaseWebComponentController';
import { CompanyAuthenticationFormWebComponent } from '../component/CompanyAuthenticationFormWebComponent';
import { GzDialogWebComponent } from '../../../../ui/gzDialog';
import { CompanyAuthenticationFormView } from '../view/CompanyAuthenticationFormView';

export class CompanyAuthenticationFormController extends BaseWebComponentController {
  public component: CompanyAuthenticationFormWebComponent;
  public view: CompanyAuthenticationFormView;
  public viewConstructor: typeof CompanyAuthenticationFormView;

  public canShow2FaDialog = true;

  private ssoSamlIdentityPreviousValue: string;

  constructor(component: CompanyAuthenticationFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: CompanyAuthenticationFormView,
      viewTemplate: templateCompanyAuthenticationForm,
    });
  }

  async render() {
    await super.render();
    this.updateCachedFields();
  }

  computeEventListeners() {
    return [];
  }

  public updateCachedFields() {
    this.ssoSamlIdentityPreviousValue = this.view.dom.$ssoSamlIdentityProviderMetadata.value;
  }

  public hasRemovedSsoProvider(): boolean {
    return !!(this.view.dom.$ssoSamlIdentityProviderMetadata.value === '' && this.ssoSamlIdentityPreviousValue);
  }

  public showIdentityProviderConfirmationWindow(confirmCallback) {
    const windowBodyHtml = `<p>
      ${this.dependencies.translateFn(
        'Deleting the identity provider metadata URL will disable the SSO as an authentication method in GravityZone. Users relying on SSO must reset their passwords from the login screen, following the link under the password field.'
      )}
      </p>`;

    const windowFooterHtml = `<gz-button id='confirm' type='outline' color='negative'>
       ${this.dependencies.translateFn('Disable')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${this.dependencies.translateFn('Cancel')}
      </gz-button>`;
    const windowTitle = this.dependencies.translateFn('Disable SSO authentication?');
    const cancelCallback = () => {
      this.view.dom.$ssoSamlIdentityProviderMetadata.value = this.ssoSamlIdentityPreviousValue;
    };

    GzDialogWebComponent.computeCustomDialog(
      windowBodyHtml,
      windowFooterHtml,
      windowTitle,
      cancelCallback,
      confirmCallback
    );
  }
}
